module.exports = __webpack_public_path__ + "static/media/gift.c37f7378.svg";